import React, { useContext } from 'react';
import { Navigate, Outlet, Route } from 'react-router-dom';
import { Context } from './../../contexts/Store'; // Update this path
import AppRouter from '../routers/AppRouter';

export const AuthRoute = () => {
    const { state } = useContext(Context);
    const isVerified = state.user_details.is_verified;

    if (!isVerified) {
        // Redirect unauthenticated users to the home page (or login page).
        return <Route path="/*" element={<Navigate to="/" />} />
    }
    
    // Render the child route's element if verified.
    return <AppRouter/>;
};
